import { styled } from 'styled-components';

export const ActiveIndicatorWrapper = styled.div`
  text-align: center;
`;
